import { t } from 'i18next';
import React, { useState } from 'react';
import { MdClose } from 'react-icons/md';

type ErrorMessagePropType = {
  errorMessage: string;
  isSticky?: boolean;
};

function ErrorMessage(props: ErrorMessagePropType) {
  const { errorMessage, isSticky = true } = props;
  const [isOpen, setOpen] = useState(Boolean(errorMessage));

  if (!isOpen) {
    return null;
  }

  return (
    <div
      className={`flex justify-between p-space-4 bg-accent-pink rounded duration-500 animate-fadeInDown mb-space-4 ${
        isSticky ? 'fixed w-full z-20 left-0' : 'static'
      }`}
    >
      <div
        tabIndex={0}
        className='text-main font-inter-medium px-space-2'
        aria-label={t('ERROR') + ': ' + errorMessage}
      >
        <span>{errorMessage}</span>
      </div>
      <button onClick={() => setOpen(false)} aria-label={t('CLOSE_ERROR')}>
        <MdClose size={18} />
      </button>
    </div>
  );
}

export default ErrorMessage;
